import { render, staticRenderFns } from "./Hackathon.vue?vue&type=template&id=18a1e285&scoped=true&"
import script from "./Hackathon.vue?vue&type=script&lang=js&"
export * from "./Hackathon.vue?vue&type=script&lang=js&"
import style0 from "./Hackathon.vue?vue&type=style&index=0&id=18a1e285&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a1e285",
  null
  
)

export default component.exports